import {
  Component,
  OnInit,
} from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { onSnapshot, Timestamp } from "firebase/firestore";
import { NGXLogger } from "ngx-logger";
import { MenuItem, MessageService } from "primeng/api";

import {
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { CategoriaVincolo } from "src/app/models/categoriaVincolo.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { ListeService } from "src/app/services/liste.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-sopralluogo-fase1",
  templateUrl: "./dialog-sopralluogo.component.html",
  styleUrls: ["../shared.component.css"],
})
export class DialogEsitoSopralluogoFase1 implements OnInit {
  protected _onDestroy = new Subject<void>();
  public pratica: PraticaFlowdy2_Firestore;
  public colocate: PraticaFlowdy2_Firestore[]=[];
  protected isComunicandoEsitoSopralluogo:boolean = false;
  protected esitoOK:boolean = true;
  protected lavoriNecessari:boolean = false;
  protected permessoNecessario:boolean = false;
  protected disableKOButton:boolean = false;

  public comunicaEsitoSopralluogoForm: FormGroup;
  public permessoForm: FormGroup;
  public lavoriExtraForm: FormGroup;

  protected pagineComunicaEsitoSopralluogo: MenuItem[];
  protected activeIndex: number = 0;

  protected label:string="Cerca file del preventivo";
  protected icona:string="";
  protected stile:string="btn-choose-file-preventivo";
  protected filePreventivoClass:string="";

  protected labelConferma:string="Conferma saltando gli altri step";
  protected severityConferma:string=""

  protected filePreventivo: File;

  private collection_pratiche:string = environment.firebase.collection_pratiche;
  protected categorieSopralluogoKO:CategoriaVincolo[]=[];

  esiti =   [
    { label: 'OK', value: 'OK', styleClass: 'esito-ok' },
    { label: 'KO', value: 'KO', styleClass: 'esito-ko' },
  ]; 

  lavoriExtra = [
    { label: 'NO', value: 'NO', styleClass: 'esito-ko' },
    { label: 'SI', value: 'SI', styleClass: 'esito-ok' },
  ];

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private googleStorageService: GoogleStorageService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private praticheService:PraticheService,
    public firestore: AngularFirestore,
    public listeService:ListeService,
    public stiliService:StiliService,
    private utilService:UtilService
  ) {
    this.pratica          = this.config.data.pratica;
    if(this.pratica.colocata){
      this.getColocate();
    }
    this.icona = 'pi pi-file-pdf';
    this.filePreventivoClass = 'btn-choose-file-preventivo';
    const dataSopralluogo = this.pratica.dataSopralluogo 
    ? this.convertFirestoreTimestampToDate(this.pratica.dataSopralluogo) 
    : null;
    this.comunicaEsitoSopralluogoForm = this.formBuilder.group({
          esito:            [ "OK", [Validators.required]],
          dataEsecuzione:   [ dataSopralluogo, [Validators.required]],
          noteSopralluogo:  [ null],
          causaKO:  [ " ", [Validators.required]],
    });
    this.comunicaEsitoSopralluogoForm.get('esito')?.valueChanges.subscribe((value) => {
      if(value==='OK'){
        this.esitoOK = true;
        this.severityConferma = "";
        this.labelConferma = "Conferma saltando gli altri step";
      }else{
        this.esitoOK = false;
        this.labelConferma = "Conferma esito KO";
        this.severityConferma = "warning";
      }
    });
   this.lavoriExtraForm = this.formBuilder.group({
          lavoriNecessari:  [ "NO", [Validators.required]],
          preventivo:       [ null, [Validators.required]],
          noteLavoriExtra:  [ null],
    });

    this.lavoriExtraForm.get('lavoriNecessari')?.valueChanges.subscribe((value) => {
      if(value==='SI'){
        this.lavoriNecessari = true;
      }else{
        this.lavoriNecessari = false;
      }
    });
    this.permessoForm = this.formBuilder.group({
      permessoNecessario:  [ "NO", [Validators.required]],
      notePermesso:  [ null],
    }); 
    this.permessoForm.get('permessoNecessario')?.valueChanges.subscribe((value) => {
      if(value==='SI'){
        this.permessoNecessario = true;
      }else{
        this.permessoNecessario = false;
      }
    });
  }


  ngOnInit(): void {
   this.inizializzaSteps();
   this.loadCategorieKO();
  }

  private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
        return timestamp.toDate();
      }

  protected getPrimoCarattereNumerico(value: any): number {
    if (!value) return 0;
    const strValue = String(value);
    const primoCarattere = strValue.charAt(0);
    return parseInt(primoCarattere) || 0;
  }

  loadCategorieKO(){
    this.utilService.getCategorieSopralluogoKO().subscribe((categorieVincolo) => {
      this.categorieSopralluogoKO = categorieVincolo;
      this.listeService.setOpzioniCausaKO(this.categorieSopralluogoKO.map(categoria => ({
        label: categoria.label,
        value: categoria.codice
      })));
    });
  }

  inizializzaSteps() {
    this.pagineComunicaEsitoSopralluogo = [
      {
        label: "Esito",
      },
      {
        label: "Lavori Extra",
      },
      {
        label: "Permesso",
      },
      
    ];
    this.activeIndex = 0;
  }

  checkNextStep(): boolean {
    let disableNextStepButton = false;
    if (this.activeIndex === this.pagineComunicaEsitoSopralluogo.length - 1) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 0 && (!this.esitoOK || !this.comunicaEsitoSopralluogoForm.valid)) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 1 && (!this.lavoriNecessari && !this.lavoriExtraForm.valid) ) {
      disableNextStepButton = true;
    }/*else if (this.activeIndex === 2 && !this.permessoForm.valid ) {
      disableNextStepButton = true;
    } */
    return disableNextStepButton;
  }
  changePage() {
    this.activeIndex = this.activeIndex + 1;
  
  }
  
  onPreventivoFileUpload(){

  }

  onPreventivoFileSelect($event: { files: File[]; }) {
    this.label = 'File del preventivo caricato';
    this.icona = "pi pi-check";
    this.filePreventivoClass = "btn-preventivo-upload-success";
    this.filePreventivo = $event.files[0];
  }  

  getColocate(){
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    const query = collectionRef .where("colocataScuolaPrincipale", "==", this.pratica.cui);
    onSnapshot(query, async (qs) => {
      this.colocate =[];
      qs.forEach((doc) => {
        let pratica = doc.data() as PraticaFlowdy2_Firestore;

        this.colocate.push(pratica);
     });
    });
  }

  onEsitoChange(value: string) {
    this.logger.info(value);
    if(value==='OK'){
      this.esitoOK = true;
      this.comunicaEsitoSopralluogoForm.patchValue({
        causaKO: ""
      });
    }else{
      this.esitoOK = false;
      this.comunicaEsitoSopralluogoForm.patchValue({
        causaKO: this.categorieSopralluogoKO[0]?.codice || ""
      });
    }
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isComunicandoEsitoSopralluogo = true;
      let esito:SopralluogoFase1DTO = new SopralluogoFase1DTO();
      esito.dataEsecuzione                = this.comunicaEsitoSopralluogoForm.value.dataEsecuzione;
      esito.noteSopralluogo               = this.comunicaEsitoSopralluogoForm.value.noteSopralluogo;
      esito.sopralluogoConEsitoPositivo   = this.comunicaEsitoSopralluogoForm.value.esito==='OK';
      if(!this.esitoOK){
        esito.causaKO               = this.comunicaEsitoSopralluogoForm.value.causaKO;
        esito.categoriaVincolo   = this.categorieSopralluogoKO.find(categoria => categoria.codice === this.comunicaEsitoSopralluogoForm.value.causaKO);
        this.logger.info("Categoria Vincolo KO: " + JSON.stringify(esito.categoriaVincolo));
      }
      if(this.lavoriNecessari){
        esito.necessarieOpereExtra = true;
        esito.preventivoOpereExtra = this.lavoriExtraForm.value.preventivo;
        esito.noteOpereExtra       = this.lavoriExtraForm.value.noteLavoriExtra;
      }

      if(this.permessoNecessario){
        esito.necessariaRichiestaPermesso = true;
        esito.noteRichiestaPermesso       = this.permessoForm.value.notePermesso;
      }

      this.praticheService.comunicaEsitoSopralluogo(this.pratica.id, esito).subscribe( {
          next: (res) => {
            //caricamento file + aggiornamento firestore
            if(this.filePreventivo!=null){
              if(!this.pratica.colocata){
                const fileName = this.pratica.cui + "/IN/FASE_1/preventivo/" + this.pratica.cui+".pdf";
                  this.googleStorageService
                  .uploadFileScuolaToGoogleStorage(this.filePreventivo, fileName)
                  .then((uploadRes) => {
                    this.praticheService.comunicaCaricamentoFilePreventivo(this.pratica.id).subscribe({
                      next: (res) => {  
                        this.isComunicandoEsitoSopralluogo = false;
                    
                        this.dialogRef.close({ success: true});
                      },
                      error: (e) => {
                        this.isComunicandoEsitoSopralluogo = false;
                        this.dialogRef.close({ success: false});
                        this.messageService.add({
                          severity: "info",
                          summary: "Errore" , life:10000,
                            detail: "Errore in fase di comunicazione dell'avvenuto caricamento del preventivo!",
                          });
                      },
                      complete: () => {
          
                      }
                    });
                  
                  })
                  .catch((errore) => {
                    this.messageService.add({
                      severity: "info",
                      summary: "Errore" , life:10000,
                        detail: "Errore in fase di caricamento del file del preventivo!",
                      });
                    
                    this.dialogRef.close({ success: false });
                  });
              }else{
                //carico per la principale + tutte le colocate
                const fileName = this.pratica.cui + "/IN/FASE_1/preventivo/" + this.pratica.cui+".pdf";
                this.googleStorageService
                .uploadFileScuolaToGoogleStorage(this.filePreventivo, fileName)
                .then((uploadRes) => {
                  this.praticheService.comunicaCaricamentoFilePreventivo(this.pratica.id).subscribe({
                    next: (res) => {  
                      this.isComunicandoEsitoSopralluogo = false;
                  
                      this.dialogRef.close({ success: true});
                    },
                    error: (e) => {
                      this.isComunicandoEsitoSopralluogo = false;
                      this.dialogRef.close({ success: false});
                      this.messageService.add({
                        severity: "info",
                        summary: "Errore" , life:10000,
                          detail: "Errore in fase di comunicazione dell'avvenuto caricamento del preventivo!",
                        });
                    },
                    complete: () => {
        
                    }
                  });
                
                })
                .catch((errore) => {
                  this.messageService.add({
                    severity: "info",
                    summary: "Errore" , life:10000,
                      detail: "Errore in fase di caricamento del file del preventivo!",
                    });
                  
                  this.dialogRef.close({ success: false });
                });

                this.colocate.forEach(colocata => {
                  const fileName = colocata.cui + "/IN/FASE_1/preventivo/" + colocata.cui+".pdf";
                  this.googleStorageService
                  .uploadFileScuolaToGoogleStorage(this.filePreventivo, fileName)
                  .then((uploadRes) => {
                    this.praticheService.comunicaCaricamentoFilePreventivo(colocata.id).subscribe({
                      next: (res) => {  
                        
                      },
                      error: (e) => {
                        this.isComunicandoEsitoSopralluogo = false;
                        this.dialogRef.close({ success: false});
                        this.messageService.add({
                          severity: "info",
                          summary: "Errore" , life:10000,
                            detail: "Errore in fase di comunicazione dell'avvenuto caricamento del preventivo!",
                          });
                      },
                      complete: () => {
          
                      }
                    });
                  
                  })
                  .catch((errore) => {
                    this.messageService.add({
                      severity: "info",
                      summary: "Errore" , life:10000,
                        detail: "Errore in fase di caricamento del file del preventivo!",
                      });
                    
                    this.dialogRef.close({ success: false });
                  });
                });

                this.isComunicandoEsitoSopralluogo = false;
                this.dialogRef.close({ success: true});
                 
              }
              
            }else{
              this.isComunicandoEsitoSopralluogo = false;
              this.dialogRef.close({ success: true });
            }
           
          },
          error: (e) => {
            this.isComunicandoEsitoSopralluogo = false;
          },
          complete: () => {

          }
      }); 
    }
  }

}